<script setup lang="ts">
import IconBase from '../IconBase.vue';
</script>

<template>
  <IconBase class="icon-loading">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 12C5 8.13401 8.13401 5 12 5C12.8284 5 13.5 4.32843 13.5 3.5C13.5 2.67157 12.8284 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22V19C8.13401 19 5 15.866 5 12Z"
        fill="url(#paint0_linear_20289_118)"
      />
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 11.1716 21.3284 10.5 20.5 10.5C19.6716 10.5 19 11.1716 19 12C19 15.866 15.866 19 12 19V22Z"
        fill="url(#paint1_linear_20289_118)"
      />
      <defs>
        <linearGradient id="paint0_linear_20289_118" x1="12" y1="2" x2="12" y2="22" gradientUnits="userSpaceOnUse">
          <stop />
          <stop offset="0.849339" stop-opacity="0.35" />
        </linearGradient>
        <linearGradient id="paint1_linear_20289_118" x1="12" y1="11" x2="12" y2="22" gradientUnits="userSpaceOnUse">
          <stop stop-opacity="0" />
          <stop offset="0.727273" stop-opacity="0.35" />
        </linearGradient>
      </defs>
    </svg>
  </IconBase>
</template>

<style lang="stylus" scoped>
.icon-loading
  animation loading .75s linear infinite

@keyframes loading
  from
    transform rotate(0deg)

  to
    transform rotate(360deg)
</style>
